import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { MinusButton, PlusButton } from "../../../components/Buttons";
import { searchShopInfoList } from "../../../http/api/CustomerAPI";
import ClientAndShopSection from "./ClientAndShopSection";
import CustomerSelect from "./CustomerSelect";
import ShopSelect from "./ShopSelect";


const UsingShopTableRow = ({
  usingShops,
  shop,
  onClickPlusButton,
  onClickMinusButton,
  disabledMinusButton,
  index,
  onChangeShop,
  errors,
  customerShops
}) => {
  const selectedCustomerId = shop.customerId;
  const selectedShopId = shop.shopId;

  const customerIdError = errors.customerId;
  const shopIdError = errors.shopId;
  const validateErr = `${customerIdError}${shopIdError}`;

  const shopsToSelect = filterShops(customerShops, selectedCustomerId);

  return (
    <Box display={"flex"} flexDirection={"column"}
      sx={{ paddingY: 1 }}
    >
      <Box display={"flex"} justifyContent={"center"} alignItems={"center"} flexDirection={"row"} sx={{ paddingY: 1 }} >
        <ClientAndShopSection title="取引先">
          <CustomerSelect
            name={`usingShopList[${index}].customerId`}
            value={selectedCustomerId}
            onChange={(e) => {
              onChangeShop({
                customerId: e.target.value,
                shopId: filterShops(customerShops, e.target.value)[0].shopId
              })
            }}
            sx={{ width: 300 }}
           />
        </ClientAndShopSection>

        <ClientAndShopSection title="店舗名" >
          <ShopSelect
            name={`usingShopList[${index}].shopId`}
            value={selectedShopId}
            onChange={(e) => onChangeShop({customerId: selectedCustomerId, shopId: e.target.value})}
            setValue={(value) => onChangeShop({customerId: selectedCustomerId, shopId: value})}
            sx={{ width: 300 }}
            listShop={shopsToSelect}
            disabled={!selectedCustomerId} // 取引先未選択なら、店舗名も未選択
          />
        </ClientAndShopSection>

        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '1mm' }}>
          <div style={{ marginRight: '3mm' }}>
            <PlusButton onClick={onClickPlusButton} />
          </div>
          <MinusButton
            onClick={onClickMinusButton}
            sx={{
              color: 'red',
              borderColor: 'red',
              '&:hover': {
                color: 'darkred',
                borderColor: 'darkred',
              },
              '&:disabled' : {
                color: 'lightgrey',
                borderColor: 'lightgrey',
              }
            }}
            disabled={disabledMinusButton}
          />
        </div>
      </Box>
      <Typography sx={{ fontSize: 12, color: "#d32f2f" }}>{validateErr}</Typography>
    </Box>

  );
};

export default UsingShopTableRow;

const filterShops = (customerShops, customerId) =>  {
  let filteredShops = customerShops.filter((shop) => shop.customerId === customerId);

  // 店舗が2以上ある場合、未選択を追加する
  if (filteredShops.length >= 2) {
    const notSelectShop = { shopId: 0, shopName: "未選択" };
    filteredShops = [notSelectShop, ...filteredShops];
  }

  return filteredShops;
}
